import React from 'react';
import { Skeleton } from '../shadcn/ui/skeleton';

export const TableSkeleton = ({ columns, rows = 5 }) => {
    return (
        <table className="w-full border-collapse text-sm">
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th
                            key={column.Header}
                            className="whitespace-nowrap px-5 py-3 text-left"
                        >
                            {column.Header}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {Array.from({ length: rows }).map((_, rowIdx) => (
                    <tr key={rowIdx}>
                        {columns.map((column) => (
                            <td
                                key={column.Header}
                                className="whitespace-normal border-b px-5 py-3 sm:whitespace-nowrap"
                            >
                                <Skeleton className="h-4 w-full min-w-52" />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
